import { API_ENDPOINTS } from "@utils/api/endpoints";

export default async function (idPost, body, update = false) {
  const { data, error, status } = await useApiFetch(API_ENDPOINTS.CATALOGUE_POST_ID_RATING, {
    method: update ? 'PUT' : 'POST',
    path: { idPost },
    body
  });

  if (status.value === 'error') {
    sentryCaptureEvent({
      message: 'catalogue-post-rating',
      level: 'error',
      extra: { error: error.value }
    });

    return null;
  }

  return data.value;
}
